'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudyOutline = function IoIosCloudyOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.3 13.8c-2.7 0-5 2.1-5 4.8v0.9l0.1 0.8c-0.4 0-0.9 0.1-1.1 0.1-1.5 0.2-2.6 1.4-2.6 2.9 0 0.8 0.3 1.5 0.8 2s1.3 0.9 2.1 0.9h12.2c2.1 0 3.9-1.7 3.9-3.9s-1.8-3.9-3.9-3.9c-0.1 0-0.3 0.1-0.4 0.1l-1.1 0.2-0.3-1.1c-0.2-1.1-0.8-2.1-1.7-2.8s-1.9-1-3-1z m0-1.3c2.9 0 5.3 2 5.9 4.8h0.6c2.8 0 5.1 2.2 5.1 5s-2.3 5.2-5.1 5.2h-12.2c-2.2 0-4.1-1.9-4.1-4.1 0-2.1 1.6-4 3.7-4.2v-0.6c0-3.4 2.7-6.1 6.1-6.1z' })
        )
    );
};

exports.default = IoIosCloudyOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloudy-outline.js
// module id = 2362
// module chunks = 0